import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { GiphySearchResult } from './model';

@Injectable({
  providedIn: 'root',
})
export class GiphyApiService {
  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  fetchGifsBySearchInput(searchText: string): Observable<GiphySearchResult> {
    const gifSearchURL = environment.giphyApi.searchUrl;
    const params = new HttpParams().set('api_key', environment.giphyApi.apiKey).set('q', searchText);

    return this.http
      .get<GiphySearchResult>(gifSearchURL, { params })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  fetchTrendingGifs(): Observable<GiphySearchResult> {
    const gifTrendingURL = environment.giphyApi.trendingUrl;
    const params = new HttpParams().set('api_key', environment.giphyApi.apiKey);

    return this.http
      .get<GiphySearchResult>(gifTrendingURL, { params })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
